import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, inject, Output } from '@angular/core';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AllUserService } from '@nimmsta/ng-commons-lib/services/user';
import { ErrorComponent } from '@nimmsta/ng-commons-lib/error';
import { Organization, User } from '@nimmsta/ng-commons-lib/models';
import { OrganizationService } from '@nimmsta/ng-commons-lib/services/organization';
import { SaveableFormComponent } from '@nimmsta/ng-commons-lib/forms';
import { LaddaModule } from 'angular2-ladda';
import { InputGroupModule } from 'primeng/inputgroup';
import { Select } from 'primeng/select';

@Component({
  selector: 'app-user-change-primary-org',
  templateUrl: 'user-change-primary-org.component.html',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    InputGroupModule,
    LaddaModule,
    ErrorComponent,
    Select,
    TranslatePipe,
  ],
})
export class UserChangePrimaryOrgComponent extends SaveableFormComponent<User> {
  private fb = inject(FormBuilder);
  private organizationService = inject(OrganizationService);

  protected override dataService = inject(AllUserService);

  @Output() override closeEvent = new EventEmitter();

  @Output() override loadingEvent = new EventEmitter<boolean>();

  organizations: Organization[] = [];

  organizationsLoading = false;

  constructor() {
    super();
    this.setValue({} as User);
  }

  protected override setFormGroup(): void {
    this.form = this.fb.group({
      organization: [this.value?.organization?.id, Validators.required],
    });

    console.log('Form group set:', this.form);
  }

  override onSave(): void {
    if (this.form.pristine && this.form.valid) {
      this.closeEvent.emit();
      return;
    }

    if (this.form.valid) {
      this.error = undefined;
      this.form.disable();
      this.loadingEvent.emit(true);
      this.value = Object.assign(this.value, this.form.value);

      this.dataService
        .changePrimaryOrganization(this.value.id, this.value.organization.id)
        .subscribe({
          next: () => {
            this.loadingEvent.emit(false);
            this.closeEvent.emit();

            this.form.markAsPristine();
            this.form.enable();
          },
          error: (error: HttpErrorResponse) => {
            this.error = error;
            this.loadingEvent.emit(false);
            this.form.enable();
          },
        });
    } else {
      this.form.markAllAsTouched();
    }
  }

  loadOrganizations(): void {
    this.organizations = [];
    this.organizationsLoading = true;

    this.organizationService
      .list({ filter: null, sortColumn: 'name', pageSize: 9999 })
      .subscribe({
        next: (response) => {
          setTimeout(() => {
            this.organizations = response.content;
            this.organizationsLoading = false;
          }, 0);
        },
        error: (error: HttpErrorResponse) => {
          this.error = error;
          this.organizationsLoading = false;
        },
      });
  }
}
